export { default } from './StickyPromoDrawer.vue';